import axios from 'axios'
import { constants } from '../../../client/js/component/helpers/helperGeotab'
import { api } from "../apiCore";
import { invalidateByPrefix } from '../apiCache';

export function deviceAddGeotabSerialN(data) {
	const url = `/geotab/device/${data.device_id}`;
	const form = new FormData();
	form.append('serial_number', data.serial_number);

	return api.putForm(url, form).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}

export function getCompanyGeotabData(data) {
	let url = `/company/geotab/partner/${data.partner_name}/companies/${data.company_name}`
	if (data.get_p) {
		url += '?p=true'
	}

	return api.get(url)
}

export function companyHash(hash) {
	const url = `/company/hash/${hash}`;

	return api.get(url)
}

export function companyCheckFakeEmails(hash){
	const url = `/company/hash/${hash}/fakeemails`;

	return api.get(url)
}

// https://mypreview.geotab.com/apiv1/Get?typeName=SystemSettings&credentials={%22database%22:%22rosco_demo%22,%22userName%22:%22romabogdan@gmail.com%22,%22sessionId%22:%22TR4SAItioZy3Ct0JvU0C0A%22}
// export function getSystemSettings(data){
// 	const url = `https://${data.path}/apiv1/Get?typeName=SystemSettings&credentials={database:"${data.database}",userName:"${data.email}",password:"${data.password}"}`;
//
// 	return api.get(url)
// }

export function insertGeotabCompany (data) {
	const url = `/company/geotab/${data.company_id}`;

	const form = new FormData();
	if (data.database)
		form.append('database', data.database);
	if (data.email)
		form.append('email', data.email);
	if (data.password)
		form.append('password', data.password);
	if (data.sessionId)
		form.append('session_id', data.sessionId);
	if (data.path)
		form.append('path', data.path);
	if (data.fleet_token)
		form.append('token', data.fleet_token);

	return api.putForm(url, form).then((res) => {
		invalidateByPrefix('company_by_id:');
		return res;
	});
}

export function deleteGeotabCompany(data) {
	const url = `/company/geotab/${data.company_id}`;

	return api.delete(url).then((res) => {
		invalidateByPrefix('company_by_id:');
		return res;
	});
}

export function getGeotabCompanies(data) {
	let url = `/geotab/companies`
	if (data.get_password) {
		url += '?p=true'
	}

	return api.get(url)
}

// FWSD-5109
export function getGeotabCompanyByCompanyId(data) {
	let url = `/company/geotab/${data.company_id}`
	if (data.get_p) {
		url += '?p=true'
	}

	return api.get(url)
}

// WEBFLEET APIs
export function loginUserExternalService(data) {
	const url = `/external_service/login`

	const form = new FormData()
	form.append('access_hash', data.access_hash)

	return api.postForm(url, form);
}

export function getWebfleetToken(data) {
	const url = `https://csv.webfleet.com/extern?account=${data.account}&username=${data.username}&password=${data.password}&lang=en&action=createSession&outputformat=json&apikey=${constants.webfleet_apikey}`

	return api.get(url)
}

export function getWebfleetVehicles(data) {
	let url = ''
	if (data.sessiontoken) {
		url = `https://csv.webfleet.com/extern?sessiontoken=${data.sessiontoken}&outputformat=json&action=showVehicleReportExtern&apikey=${constants.webfleet_apikey}`
	}
	else {
		url = `https://csv.webfleet.com/extern?account=${data.account}&username=${data.username}&password=${data.password}&lang=en&outputformat=json&action=showVehicleReportExtern&apikey=${constants.webfleet_apikey}`
	}

	return api.get(url)
}

// FWSD-5295
export function setWebfleetCard(data) {
	const cardConfig = constants.WEBFLEET_CARD_CONFIG
	const env = location.hostname
	let domain = 'fleet.roscolive.com';
	switch (env) {
		case 'localhost':
		case 'test.roscolive.com':
			domain = 'test.roscolive.com'
			break
		case 'staging.roscolive.com':
			domain = 'staging.roscolive.com'
			break
		default:
			break
	}

	cardConfig.externalLinks.value[0].href['en-US'] = `https://${domain}/webfleet/device/${data.access_hash}/${data.webfleet_sn}`
	// https://fleet.roscolive.com/webfleet/device/gAAAAABkLGhnJ4y-ecm9jSn1kDEH_3MbsdLm9lkpyumMrDChkcVWo44uBtRa8ZD22auvAu5NTua31kZpdhBR1RN-imxnKHZyk8h4XDlGDNURYttwQpXn4V3FVJlUrXiOBWU1SgAt_pyw/1-48217-4660622C3A
	cardConfig.data[0][0].value['en-US'] = data.vehicle_name || ''
	cardConfig.data[1][0].value['en-US'] = data.online ? 'Online' : 'Offline'

	const url = `https://csv.webfleet.com/extern?account=${data.account}&username=${data.username}&password=${data.password}&lang=en&action=setExternalObjectData&objectuid=${data.webfleet_sn}&apikey=${constants.webfleet_plugin_card_apikey}&data=${JSON.stringify(cardConfig)}`

	// https://csv.webfleet.com/extern?account=roscoy&username=Roman&password=Roman2012&lang=en&action=setExternalObjectData&objectuid=1-48217-0503015F1E&apikey=40d126f5-ef7a-4ba7-bafb-0c267e2cf78d&data={"version":"1.0.0","defaultLocale":"en-US","title":{"en-US":"RoscoLive"},"externalLinks":{"name":{"en-US":"External links"},"value":[{"href":{"en-US":"https://fleet.roscolive.com"},"title":{"en-US":"Go to RoscoLive"},"description":{"en-US":"By clicking you will be redirected to the RoscoLive App."}}]},"data":[[{"name":{"en-US":"Camera Name"},"value":{"en-US":"Truck 004"}}],[{"name":{"en-US":"Network Status"},"value":{"en-US":"Off"}}]]}

	const settings = {
		url,
		method: 'POST', // ToDo: JWT Geotab
	}

	return axios(settings)
}

// ITURAN APIs
export function getIturanToken(data) {
	const options = {
		method: 'POST', // ToDo: JWT Geotab
		url: 'https://api.ituran.com/api/v1/oauth/token',
		headers: {'Content-Type': 'application/json', Accept: 'application/json'},
		data
	}

	return axios.request(options)
}

export async function getIturanVehicles(args) {
	const options = {
		method: 'POST', // ToDo: JWT Geotab
		url: 'https://api.ituran.com/api/v1/oauth/token',
		headers: {'Content-Type': 'application/json', Accept: 'application/json'},
		data: args,
	}
	const { data } = await axios.request(options)

	const options1 = {
		method: 'GET',
		url: 'https://api.ituran.com/api/v2/vehicles?page_number=1&page_size=2000',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${data.access_token}`
		}
	}

	return axios.request(options1)
}

export function uploadVehiclesGeotab(data) {
	const url = `/geotab/companies/${data.company_id}/devices/file`;

	const form = new FormData();
	form.append('file', data.file);

	return api.putForm(url, form).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}
